<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="5" :sm="10">
            <a-form-item label="项目编号">
              <a-input placeholder="请输入项目编号" v-model="queryParam.projNum"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="10">
            <a-form-item label="项目名称">
              <a-input placeholder="请输入项目名称" v-model="queryParam.name"/>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="10">
            <a-form-item label="客户名称">
              <j-search-select-tag type="list" v-model="queryParam.customer" 
              dict="biz_customer,name,id" 
              :async = "true"
              placeholder="请输入至少两个汉字查询"/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="6">
            <a-form-item label="包含下级">
              <a-checkbox v-model="queryParam.includeSubCustomer">
              </a-checkbox>
            </a-form-item>
          </a-col>

          <template v-if="toggleSearchStatus">
            <a-col :md="5" :sm="10">
              <a-form-item label="项目类型">
                <j-dict-select-tag
                  placeholder="请选择项目类型"
                  v-model="queryParam.type"
                  dictCode="bms_project_type">
                </j-dict-select-tag>
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="8">
              <a-form-item label="提交人">
                <j-search-select-tag
                  placeholder="请选择提交人"
                  v-model="queryParam.committer"
                  dict="sys_user,realname,username,del_flag=0">
                </j-search-select-tag>
              </a-form-item>
            </a-col>
            <!-- <a-col :md="6" :sm="10">
              <a-form-item label="申请人部门">
                <j-search-select-tag
                  placeholder="请选择申请人部门"
                  v-model="queryParam.committerDepart"
                  dict="sys_depart,depart_Name,org_Code">
                </j-search-select-tag>
              </a-form-item>
            </a-col> -->

            <a-col :md="6" :sm="8">
              <a-form-item label="提交日期">
                <a-range-picker
                  style="width: 220px"
                  v-model="queryParam.commitTimeRange"
                  format="YYYY-MM-DD"
                  :placeholder="['开始日期', '结束日期']"
                  @change="onDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col :md="5" :sm="10">
              <a-form-item label="状态">
<!--                <j-dict-select-tag-->
<!--                  placeholder="选择状态"-->
<!--                  v-model="queryParam.status"-->
<!--                  dictCode="bms_project_status"-->
<!--                  >-->
<!--                </j-dict-select-tag>-->
                <a-select v-model="queryParam.status" placeholder="选择状态" :getPopupContainer= "(target) => target.parentNode" style="width: 150px">
                  <a-select-option value="">请选择</a-select-option>
                  <a-select-option value="20">项目立项中</a-select-option>
                  <a-select-option value="21">立项审核中</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>

          <a-col :md="4" :sm="10">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? '收起' : '展开' }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus" v-has="'projectInitiationList:add'">新增</a-button>
      <a-button type="primary" icon="download" @click="handleDownloadTemplate" v-has="'projectInitiationList:downloadTemplate'">模板下载</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls('项目立项表')" v-has="'projectInitiationList:export'">导出</a-button>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(downUrl+text)">
            下载
          </a-button>
        </template>

        <span slot="delayFlagSlot" slot-scope="text">
          {{getDelayFlagText(text)}}
        </span>

        <span slot="action" slot-scope="text, record">
          <a @click="handleDetail(record)">详情</a>
          <a-divider type="vertical"/>

          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item v-has="'projectInitiationList:edit'" v-show="record.status==projectStatus.INITATION_WAIT">
                <a  @click="handleEdit(record)">编辑</a>
              </a-menu-item>
              <a-menu-item v-has="'projectInitiationList:del'" v-show="record.status==projectStatus.INITATION_WAIT">
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
              <a-menu-item v-has="'projectInitiationList:commit'" v-show="record.status==projectStatus.INITATION_WAIT">
                <a  @click="handlecommitInitiation(record)" >提交审核</a>
              </a-menu-item>

              <a-menu-item v-has="'projectInitiationList:cancel'" v-show="record.status==projectStatus.INITATION_AUDIT">
                <a @click="handleauditInitiation(record,projectStatus.CANCEL)" >撤销</a>
              </a-menu-item>
              <a-menu-item v-has="'projectInitiationList:return'" v-show="record.status==projectStatus.INITATION_AUDIT">
                <a @click="handleauditInitiation(record,projectStatus.INITATION_WAIT)" >退回</a>
              </a-menu-item>
              <a-menu-item v-has="'projectInitiationList:auditPass'" v-show="record.status==projectStatus.INITATION_AUDIT">
                <a @click="handleauditInitiation(record,projectStatus.IDEA_WAIT)" >审核通过</a>
              </a-menu-item>
              <!--   -->
              <a-menu-item v-has="'projectInitiationList:delay'" v-show="(record.status > projectStatus.INITATION_AUDIT && record.status < projectStatus.SERVICING) && record.delayedFlag =='0'"> 
                <a  @click="handleDelayInitiation(record)" >延期</a>
              </a-menu-item>

            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <project-initiation-modal ref="modalForm" @ok="modalFormOk"></project-initiation-modal>
    <a-modal v-model="templateModalVisible" title="模板下载" @ok="handleTemplateOK">
      <a style="margin-right:30px;" :href="`${path}授权委托书模板.doc`" download="授权委托书模板.doc">授权委托书模板</a>
      <a style="margin-right:30px;" :href="`${path}合作协议模板.doc`" download="合作协议模板.docx">合作协议模板</a>
    </a-modal>
    <a-modal v-model="modalVisible" :title="auditRemarkTitle" @ok="handleAuditRemarkOK">
      <label style="margin-bottom: 10px;display: block;">{{auditRemarkTitle}}：</label>
      <a-textarea rows="3" max-length="255" placeholder="请输入简要描述" v-model="auditRemark" :trigger-change="true" />
    </a-modal>
  </a-card>
</template>风险

<script>

  import '@/assets/less/TableExpand.less'
  import { filterObj } from '@/utils/util'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JSearchSelectTag from '@/components/dict/JSearchSelectTag'
  import { postAction} from '@/api/manage'
  import JDate from '@/components/jeecg/JDate'
  import { mapGetters } from 'vuex'
  import ProjectInitiationModal from './modules/ProjectInitiationModal'
  import ProjectConst from '../ProjectConst'
  import ProjectStatus from '../ProjectStatus'


  export default {
    name: 'ProjectInitiationList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JSearchSelectTag,
      JDate,
      ProjectInitiationModal,
    },
    data () {
      return {
        description: '项目立项列表',
        disableMixinCreated: true,
        modalVisible: false,
        templateModalVisible: false, // 模板下载窗口
        path: ProjectConst.OSS_ADR_TEMPLATE,
        projectStatus:{},
        auditRemark:'',// 撤销、退回原因
        auditRemarkTitle:'撤销原因',
        currentRecord: null, // 撤销等操作时使用
        currentStatus: null,
        downUrl:window._CONFIG['downloadUrl'],

        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'项目编号',
            className:'column-text',
            dataIndex: 'projNum',
            sorter: true
          },
          {
            title:'项目名称',
            className:"column-text",
            dataIndex: 'name',
          },
          {
            title:'状态',
            className:"column-text",
            dataIndex: 'statusName',
          },
          {
            title:'客户名称',
            className:"column-text",
            dataIndex: 'customerName'
          },

          {
            title:'授权委托书',
            className:"column-text",
            dataIndex: 'attorneyUrl',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title:'合作协议',
            className:"column-text",
            dataIndex: 'agreementUrl',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title:'中标通知书',
            className:"column-text",
            dataIndex: 'bidWinningNoticeUrl',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title:'保单',
            className:"column-text",
            dataIndex: 'policyUrl',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title:'其他',
            className:"column-text",
            dataIndex: 'otherUrl',
            scopedSlots: {customRender: 'fileSlot'}
          },
          {
            title:'提交人',
            className:"column-text",
            dataIndex: 'committerName',
          },
          {
            title:'提交时间',
            className:"column-text",
            dataIndex: 'commitTime',
          },

          {
            title:'审核人',
            className:"column-text",
            dataIndex: 'auditorName'
          },
          {
            title:'审核时间',
            className:"column-text",
            dataIndex: 'auditTime'
          },
          {
            title:'到期时间',
            className:"column-text",
            dataIndex: 'expirationTime'
          },
          {
            title:'是否延期',
            align: 'center',
            dataIndex: 'delayedFlagName',
            // scopedSlots: {customRender: 'delayFlagSlot'}
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:120,
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/project/initiation/list",
          delete: "/project/initiation/delete",
          commitInitiation: "/project/initiation/commitInitiation",
          auditInitiation: "/project/initiation/auditInitiation",
          delayInitiation: "/project/initiation/delayInitiation",
          exportXlsUrl: "/project/initiation/exportXls",
        },

      }
    },
    created() {
      this.projectStatus = ProjectStatus,
      this.projectConst = ProjectConst
    },
    methods: {
      ...mapGetters(["userInfo"]),
      initDictConfig(){
      },
      getDelayFlagText(text){
        if(text === "0"){
          return "否"
        } else if(text === "1"){
          return "是"
        } else {
          return ""
        }
      },

      handlecommitInitiation(record){
        // 提交申请
        postAction(this.url.commitInitiation,{id: record.id}).then(res =>{
          if(res.success){
            this.$message.success("提交完成")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      handleauditInitiation(record, status){
        this.auditRemark=''
        this.currentRecord = record
        this.currentStatus = status

        if(status === this.projectStatus.INITATION_WAIT || status === this.projectStatus.CANCEL){ // 退回、撤销
          if(status === this.projectStatus.INITATION_WAIT){
            this.auditRemarkTitle ='退回原因'
          } else {
            this.auditRemarkTitle = '撤销原因'
          }
          this.modalVisible = true

        } else if(status === this.projectStatus.IDEA_WAIT){ // 审核通过
          this.auditInitiation()

        }
      },

      handleAuditRemarkOK(){
        if(this.auditRemark.length<=0){
          this.$message.warn(this.auditRemarkTitle + "不能为空")
          return
        } else if(this.auditRemark.length >255){
          this.$message.warn(this.auditRemarkTitle + "长度不能超过255个字符")
          return
        }
        this.modalVisible = false;
        this.auditInitiation()
      },

      auditInitiation(){
        let record = this.currentRecord
        let status = this.currentStatus

        // 审核申请
        let param = {id: record.id, projId: record.projId,status: status,auditRemark: this.auditRemark}
        postAction(this.url.auditInitiation, param).then(res =>{
          if(res.success){
            this.$message.success("操作成功")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },

      onDateChange: function (value, dateString) {
        if(dateString.length >0 && dateString[0].length>0) {
          this.queryParam.commitTimeRange = dateString;
        } else {
          this.queryParam.commitTimeRange = null
        }
      },

      getQueryParams() {
        var param = Object.assign({}, this.queryParam, this.isorter ,this.filters)
        // 创建日期
        if(param.commitTimeRange){
          param.commitTimeBegin = param.commitTimeRange[0] + ' 00:00:00'
          param.commitTimeEnd = param.commitTimeRange[1] + ' 23:59:59'
          delete param.commitTimeRange
        }

        param.pageNo = this.ipagination.current
        param.pageSize = this.ipagination.pageSize
        return filterObj(param);
      },

      //模板下载
      handleDownloadTemplate(){
        this.templateModalVisible = true
      },
      handleTemplateOK(){
        this.templateModalVisible = false
      },

      // 延期
      handleDelayInitiation(record){
        let param = {id: record.id, projId: record.projId}
        postAction(this.url.delayInitiation, param).then(res =>{
          if(res.success){
            this.$message.success("延期成功")
            this.loadData()
          } else {
            this.$message.warning(res.message)
          }
        })
      },
    }
  }
</script>
<style>
  @import '~@assets/less/common.less';
  th.column-money {
    text-align: center !important;
  }
  td.column-money {
    text-align: right !important;
  }

  th.column-text {
    text-align: center !important;
  }
  td.column-text {
    text-align: left !important;
  }
</style>